import { useEffect, useState } from 'react';

import { BEST_RATE_ID } from '@shared/v2/constants/packages';
import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

const useAutoSelectBestRates = (hasPackageOptionsOtherThanBar: boolean) => {
  const { setSearchQuery, isReady, searchQuery } = useSearchQuery();
  const [hasDoneAutoSelect, setHasDoneAutoSelect] = useState(false);

  useEffect(() => {
    if (!isReady || hasDoneAutoSelect) {
      return;
    }

    if (
      !hasPackageOptionsOtherThanBar &&
      searchQuery?.packageOption !== BEST_RATE_ID
    ) {
      setSearchQuery({ packageOption: BEST_RATE_ID }).then(() =>
        setHasDoneAutoSelect(true),
      );
    } else {
      setHasDoneAutoSelect(true);
    }
  }, [
    hasDoneAutoSelect,
    hasPackageOptionsOtherThanBar,
    isReady,
    searchQuery?.packageOption,
    setSearchQuery,
  ]);

  return hasDoneAutoSelect;
};

export default useAutoSelectBestRates;
